// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"f4e99fbb","688":"fd7514bd"}[chunkId] + ".chunk.js";
};